import type { IDonateFormWrapperProps } from './Components/DonateForm';

async function MountDonateForm(props: IDonateFormWrapperProps, el: Element) {
	const a = await import('./Components/DonateForm');
	a.MountDonateForm(props, el);
}
(window as any).MountDonateForm = MountDonateForm;
